__turbopack_context__.v({
  "closeButton": "SearchInput-module__Vfpf_G__closeButton",
  "closeIcon": "SearchInput-module__Vfpf_G__closeIcon",
  "header": "SearchInput-module__Vfpf_G__header",
  "input": "SearchInput-module__Vfpf_G__input",
  "searchIcon": "SearchInput-module__Vfpf_G__searchIcon",
  "searchbar": "SearchInput-module__Vfpf_G__searchbar",
});
